import React, { Component, Fragment } from 'react';

import moment from 'moment';

import { toBoolean } from 'pages/utils/sanitize';

import { TimeclockBadge, TimeclockLink, TimeclockText } from './Timeclock.style';

export const calculateTimeClockDuration = (minutes) => {
  const hours = Math.floor(minutes / 60);
  const mins = String(minutes - 60 * hours);

  return `${hours}:${mins.padStart(2, '0')}`;
};

let isCheckedInState;
let checkedInAtState;

class Timeclock extends Component {
  constructor(props) {
    super(props);

    const { isCheckedIn, checkedInAt, minutes } = props;

    if (typeof isCheckedIn === 'boolean') {
      isCheckedInState = isCheckedIn;
    }

    if (typeof checkedInAt !== 'undefined') {
      checkedInAtState = checkedInAt;
    }

    this.state = {
      isCheckedIn: isCheckedInState,
      minutes: checkedInAtState ? moment().diff(checkedInAtState, 'minutes') : minutes,
    };

    this.timeclockInterval = null;
  }

  componentDidMount() {
    window.merchantos.asyncSubscribe.subscribeToFormCall(
      'sidebar.timeclock',
      ({ isCheckedIn, checkedInAt = new Date() }) => {
        isCheckedInState = toBoolean(isCheckedIn);
        checkedInAtState = toBoolean(isCheckedIn) ? checkedInAt : null;

        this.updateTimeclock({
          isCheckedIn: isCheckedInState,
          checkedInAt: checkedInAtState,
        });
      }
    );
  }

  componentWillUnmount() {
    this.setState = () => {};
    clearInterval(this.timeclockInterval);
  }

  updateTimeclock({ isCheckedIn, checkedInAt }) {
    this.setState(
      {
        isCheckedIn,
        minutes: checkedInAt ? moment().diff(checkedInAt, 'minutes') : 0,
      },
      () => {
        if (!isCheckedIn && this.timeclockInterval) {
          clearInterval(this.timeclockInterval);
          this.timeclockInterval = null;
        } else if (isCheckedIn && !this.timeclockInterval) {
          this.timeclockInterval = setInterval(() => {
            this.setState((prevState) => ({ minutes: prevState.minutes + 1 }));
          }, 60000);
        }
      }
    );
  }

  render() {
    const { onClick, ...rest } = this.props;
    const { isCheckedIn, minutes } = this.state;

    return (
      <Fragment>
        {isCheckedIn !== undefined ? (
          <TimeclockLink onClick={onClick} {...rest}>
            <TimeclockBadge type={isCheckedIn ? 'success' : 'warning'} small>
              {isCheckedIn ? 'In' : 'Out'}
            </TimeclockBadge>
            {isCheckedIn ? (
              <TimeclockText bodySmall>{calculateTimeClockDuration(minutes)}</TimeclockText>
            ) : null}
          </TimeclockLink>
        ) : null}
      </Fragment>
    );
  }
}

Timeclock.defaultProps = {
  isCheckedIn: undefined,
  checkedInAt: undefined,
  minutes: 0,
};

export default Timeclock;
